 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		392: 0,
 		277: 0,
 		278: 0,
 		281: 0,
 		283: 0,
 		284: 0,
 		286: 0,
 		287: 0,
 		288: 0,
 		341: 0,
 		342: 0,
 		348: 0,
 		349: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","215":"AddClosedAlertIDUseCase","216":"CreateDeviceUseCase","217":"CreateDomestikaFollowUseCase","218":"CreateJWTUserUseCase","219":"CreateUserLiveSessionUseCase","220":"CurrentUserUseCase","221":"CurrentWithoutRelationshipsUserUseCase","222":"DeleteDeviceUseCase","223":"DeleteFollowUseCase","224":"ENV_CONFIG1","225":"ENV_CONFIG4","226":"ENV_CONFIG5","227":"ENV_CONFIG6","228":"ENV_CONFIG7","229":"FinishUserLiveSessionUseCase","230":"GetAccessTokenUserUseCase","231":"GetAdvanceGDPRStatusUserUseCase","232":"GetAllBlogUseCase","233":"GetAreasCourseUseCase","234":"GetCartCourseUseCase","235":"GetCategoriesCourseUseCase","236":"GetCourseUseCase","237":"GetFinalProjectVideoByCourseIDCourseUseCase","238":"GetGDPRStatusUserUseCase","239":"GetListLiveFeedbackQuestionUseCase","240":"GetListLiveSessionUseCase","241":"GetListLiveStreamUseCase","242":"GetLiveChannelUseCase","243":"GetLiveSessionUseCase","244":"GetOrganizationUseCase","245":"GetPlusPromotionUseCase","246":"GetPostContentBlogUseCase","247":"GetPromotionCodeAlertUseCase","248":"GetPromotionUseCase","249":"GetPubnubCredentialsUseCase","250":"GetSessionDataUserUseCase","251":"GetSimpleUserUseCase","252":"GetSoftwaresCourseUseCase","253":"GetUserAlertUseCase","254":"GetVideoProgressListCourseUseCase","255":"GetVideoSpeedUserUseCase","256":"GetVideoVolumeUserUseCase","257":"LogoutUserUseCase","258":"PathToRegexp","259":"RefreshAccessTokenUserUseCase","260":"RemoveAccessTokenUserUseCase","261":"SearchCourseUseCase","262":"SendHeaderTrackingUseCase","263":"SendLiveFeedbackAnswersUseCase","264":"SendPlayerTrackingUseCase","265":"SendTrackingUseCase","266":"SendVideoProgressCourseUseCase","267":"SetAdvanceGDPRStatusUserUseCase","268":"SetGDPRStatusUserUseCase","269":"SetVideoSpeedUserUseCase","270":"SetVideoVolumeUserUseCase","271":"UpdateLanguageUserUseCase","272":"UpdateLiveSessionUseCase","273":"UpdateVideoAudioAndSubtitlesCourseUseCase","274":"UpdateVideoProgressCourseUseCase","275":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AlgoliaSearch","349":"vendors~AmplitudeJS","350":"vendors~SearchCourseUseCase","351":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"4433d2e6d878124624ee","1":"e750001b08d796a59388","2":"2b0226bd081b26da3b64","3":"3777e1544678b3d3c83c","4":"887f7a46cfcd64ae414c","5":"93a6739b9599ae6e9ec8","215":"d72eac1cde31f466890c","216":"0f4aae859aacc5036da8","217":"c48f6628562d4fa37563","218":"f41ead40f622819c629a","219":"8f0573e48dcc5778f033","220":"2081854de500a7642a35","221":"1e4b77ccc9bc4866cb5d","222":"91c28380ab49365b5e08","223":"e569af993cbfcfae3797","224":"b2882c8c8d9ef204afe8","225":"ee2829d2e2c37c2a5343","226":"071a3cc05e9870297b83","227":"cf69590ac28467a1d6ad","228":"b2e0e88d9ce415682f02","229":"01f966afd0cba10ff37b","230":"3ad25396b81cf4ad5f4a","231":"41edb6dc8ef734a2c4bc","232":"bfdb4568818bc1b56c32","233":"c5c9f3b056fd0fc9015d","234":"690d023c5fcf57df9450","235":"eca4fd6280b4be6d32cd","236":"cd02c92c96a20c93e92b","237":"5242e7bb96a728f9f5a7","238":"1529df4c1987084080de","239":"4871916b3a70c5e2b59a","240":"a9078925a393f45b8301","241":"2815584ff0d997bd3b4e","242":"3a522c2900de25d3410d","243":"06b26564f7231731f547","244":"ecf6eee6039d3ec2d49c","245":"fc8987042d271ba81639","246":"183490b5ae171fe83034","247":"ef43db441665a9457ae8","248":"7311b76332709388faa2","249":"a5d39af9d86f5c6f6d46","250":"f01b4e7bb7cf8250ce96","251":"4b71d923a50794756f2d","252":"a7983ea79e129ceff6ad","253":"d53d5667ebdf29839cce","254":"4ad9421d7cc167bc8506","255":"12d0dc3754927f251b9e","256":"8792b294ba4db86c8499","257":"4975dc1b6a0fc953dd4a","258":"cfec50cf79aac42845eb","259":"540c482846e82423bfc7","260":"db3cb6ec8fc25a7e154e","261":"19857336f129a685e72c","262":"7570e862be1e4bbb0ab4","263":"198e0a65bc343149c8cf","264":"2cf6f59381e4ffb917ab","265":"d6f4cd2717563b2de46c","266":"9f11eb18ebd1ae063edc","267":"e0d9ff1e654bdd046865","268":"04d9037db0df5651d24d","269":"b7a68d72c7d67e8a06c2","270":"cae8f21cbc02a7e1ca37","271":"f359240ff18de56b0f66","272":"fb430333afa941ae2b17","273":"9894cde59014d25d19f7","274":"797d408caa8bbd36052d","275":"353d7e737c840897d35f","347":"885506b8cd0d1b4f06f6","348":"e8d55baf01f11210c6dc","349":"0b558033eb6470e72b7c","350":"9b2f58b1bf05e33eb956","351":"2184235d9582340a7af2","427":"bc6cf02a362ae2137762","645":"f640f27c71553b13689c","646":"98dd199048f7d0baa7d6","647":"de69d80961de10134720"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2354);
